import React, { useEffect, useRef, createElement } from 'react';
import { SEO } from '../components/SEO';
export const AfspraakMakenPage = () => {
  const calendarRef = useRef<HTMLDivElement>(null);
  const scriptLoaded = useRef(false);
  useEffect(() => {
    // Only load the script once
    if (scriptLoaded.current) return;
    // Function to initialize Cal.com
    const initializeCalendar = () => {
      const C = window as any;
      const A = 'https://app.cal.com/embed/embed.js';
      const L = 'init';
      // Create the Cal function if it doesn't exist
      if (!C.Cal) {
        C.Cal = function () {
          const cal = C.Cal;
          const ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            document.head.appendChild(document.createElement('script')).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              api.q.push(arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              cal.ns[namespace].q = cal.ns[namespace].q || [];
              cal.ns[namespace].q.push(ar);
              cal.q.push(['initNamespace', namespace]);
            } else {
              cal.q.push(ar);
            }
            return;
          }
          cal.q.push(ar);
        };
      }
      // Initialize Cal with namespace
      C.Cal('init', 'bkcustoms', {
        origin: 'https://cal.com'
      });
      // Configure the inline calendar
      C.Cal.ns['bkcustoms']('inline', {
        elementOrSelector: '#my-cal-inline',
        config: {
          layout: 'month_view'
        },
        calLink: 'bkcustoms'
      });
      // Configure UI
      C.Cal.ns['bkcustoms']('ui', {
        styles: {
          branding: {
            brandColor: '#D6281F'
          }
        },
        hideEventTypeDetails: false,
        layout: 'month_view',
        theme: 'dark'
      });
      scriptLoaded.current = true;
    };
    // Initialize the calendar
    try {
      initializeCalendar();
    } catch (error) {
      console.error('Failed to initialize calendar:', error);
    }
    // Cleanup function
    return () => {
      try {
        const C = window as any;
        if (C.Cal && C.Cal.ns && C.Cal.ns['bkcustoms']) {
          C.Cal.ns['bkcustoms']('destroy');
        }
      } catch (error) {
        console.error('Error cleaning up Cal:', error);
      }
    };
  }, []);
  return <main className="bg-[#0a0a0a] w-full" data-id="element-585">
      <SEO title="Afspraak Maken | BKCustoms Car Styling Almere" description="Plan een afspraak voor uw auto styling of vraag een vrijblijvende offerte aan bij BKCustoms in Almere. Premium car styling diensten op maat." canonical="/afspraak-maken" data-id="element-586" />
      {/* Header Banner */}
      <div className="relative py-12 md:py-20" data-id="element-587">
        <div className="absolute inset-0 overflow-hidden" data-id="element-588">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-589"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats" className="w-full h-full object-cover object-center" data-id="element-590" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-591">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 md:mb-6" data-id="element-592">
            Afspraak <span className="text-[#D6281F]" data-id="element-593">Maken</span>
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg hidden md:block" data-id="element-594">
            Plan een afspraak voor uw auto styling of vraag een vrijblijvende
            offerte aan.
          </p>
        </div>
      </div>
      {/* Calendar Section - Simplified */}
      <section className="py-12 md:py-16" data-id="element-595">
        <div className="max-w-6xl mx-auto px-4" data-id="element-596">
          {/* Calendar container - Simplified with fewer nested containers */}
          <div id="my-cal-inline" ref={calendarRef} className="w-full min-h-[700px] md:min-h-[800px] lg:min-h-[850px] rounded-lg overflow-hidden" data-id="element-597"></div>
          <p className="text-white/60 text-sm mt-6 text-center max-w-2xl mx-auto" data-id="element-598">
            Selecteer een datum en tijd die voor u het beste uitkomt. U ontvangt
            een bevestiging per e-mail na het maken van uw afspraak.
          </p>
        </div>
      </section>
    </main>;
};